import { AppThunk } from '../../../store/rootReducer';
import * as beatsActions from '../../beats/beats.actions';
import { last } from 'lodash';
import {
  selectedBeatIdsSelector,
  sortedBeatIdsSelector,
} from '../../beats/beats.selector';

export const selectBeats =
  (beatId: number, isShiftKey = false, isCtrlKey = false): AppThunk =>
  async (dispatch, getState) => {
    const clusterBeatIds = sortedBeatIdsSelector(getState());
    const selectedBeatIds = selectedBeatIdsSelector(getState());
    if (isShiftKey) {
      const selectedBeatIdsArr = Array.from(selectedBeatIds);
      const lastSelectedBeatId = last(selectedBeatIdsArr);
      const beatIdIndex = clusterBeatIds.findIndex(
        (currentBeatId) => currentBeatId === beatId,
      );
      const lastSelectedBeatIdIndex = clusterBeatIds.findIndex(
        (currentBeatId) => currentBeatId === lastSelectedBeatId,
      );
      const [firstIndex, lastIndex] =
        beatIdIndex < lastSelectedBeatIdIndex
          ? [beatIdIndex, lastSelectedBeatIdIndex]
          : [lastSelectedBeatIdIndex, beatIdIndex];
      const beatIdsToAdd = clusterBeatIds.slice(firstIndex, lastIndex + 1);
      const updatedSelectedIds = [...selectedBeatIdsArr, ...beatIdsToAdd];
      const updatedBeatIdSet = new Set(updatedSelectedIds);

      dispatch(beatsActions.select({ ids: updatedBeatIdSet }));
    } else if (isCtrlKey) {
      const updatedBeatIdSet = new Set(selectedBeatIds);
      if (updatedBeatIdSet.has(beatId)) {
        updatedBeatIdSet.delete(beatId);
      } else {
        updatedBeatIdSet.add(beatId);
      }
      dispatch(beatsActions.select({ ids: updatedBeatIdSet }));
    } else {
      if (selectedBeatIds.size === 1 && selectedBeatIds.has(beatId)) {
        dispatch(beatsActions.select({ ids: new Set() }));
      } else {
        dispatch(beatsActions.select({ ids: new Set([beatId]) }));
      }
    }
  };
